const tableRow = document.querySelectorAll('.redirect-with-data');

if (tableRow.length > 0) {
    tableRow.forEach(row => {
        row.addEventListener('click', function () {
            const link = row.dataset.uri;
            window.location.href = link;
        });
        row.addEventListener('keydown', function (event) {
            const link = row.dataset.uri;
            if (event.key === 'Enter') {
                window.location.href = link;
            }
        });
    });
}
